import { useCallback } from 'react';

import { useUserContext } from '../context';

/**
 * Custom hook that returns a function to check user permissions.
 * This function can be used to determine if the current user has a specific permission.
 * @returns {function(string): boolean} - A function that takes a requiredPermission string and returns true if the user has the permission, false otherwise.
 */
export const useHasPermission = () => {
  const { user } = useUserContext();

  const userPermissions = new Set(user?.permissions || []);

  const hasPermission = useCallback(
    (requiredPermission) => {
      if (!requiredPermission) {
        return true;
      }
      return userPermissions.has(requiredPermission);
    },
    [userPermissions]
  );

  return hasPermission;
};
